"use strict";

require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.reduce.js");
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
var _utils = require("./utils");
var _state = require("./state");
var _XFrameClient = _interopRequireDefault(require("./XFrameClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var defaults = _lodashReplacement.default.defaults,
  extend = _lodashReplacement.default.extend,
  find = _lodashReplacement.default.find,
  cloneDeep = _lodashReplacement.default.cloneDeep,
  without = _lodashReplacement.default.without;
function listener() {
  plugin.routeMessage.apply(plugin, arguments);
}
function listenToWorker(worker) {
  if (!_state.state.workers.includes(worker)) {
    worker.addEventListener("message", listener);
    _state.state.workers.push(worker);
  }
}
_XFrameClient.default.getInstance = function getInstance(source, origin, instanceId) {
  var client = new _XFrameClient.default(source, {
    origin: origin,
    isWorker: typeof Worker !== "undefined" && source instanceof Worker
  }, instanceId);
  if (client.options.isWorker) {
    listenToWorker(client.target);
  }
  return client;
};
var NO_OP = function NO_OP() {};
var plugin = _mttPostal.default.fedx.transports.xframe = {
  eagerSerialize: _state.env.useEagerSerialize,
  XFrameClient: _XFrameClient.default,
  configure: function configure(cfg) {
    if (cfg) {
      _state.state.config = defaults(extend(_state.state.config, cfg), _state.state.defaults);
    }
    return _state.state.config;
  },
  clearConfiguration: function clearConfiguration() {
    _state.state.config = extend({}, _state.state.defaults);
  },
  //find all iFrames and the parent window if in an iframe
  getTargets: _state.env.isWorker ? function () {
    return [{
      target: {
        postMessage: postMessage
      }
    }]; // TO-DO: look into this...
  } : function () {
    var targets = Array.from(document.getElementsByTagName("iframe")).map(function (i) {
      var urlHack = document.createElement("a");
      urlHack.href = i.src;
      var origin = urlHack.protocol + "//" + urlHack.host;
      // The following condition fixes the IE issue of setting the origin while the iframe is 'empty':
      // if the iframe has no 'src' set to some meaningful url (at this very moment),
      // then the urlHack returns neither protocol nor host information.
      if (origin === "//") {
        origin = null;
      }
      return {
        target: i.contentWindow,
        origin: origin || _state.state.config.defaultOriginUrl
      };
    });
    if (window.parent && window.parent !== window) {
      targets.push({
        target: window.parent,
        origin: "*"
      });
    }
    return targets.concat(_state.state.workers);
  },
  remotes: [],
  wrapForTransport: _state.env.useEagerSerialize ? function (packingSlip) {
    return JSON.stringify({
      postal: true,
      packingSlip: packingSlip
    });
  } : function (packingSlip) {
    return {
      postal: true,
      packingSlip: packingSlip
    };
  },
  unwrapFromTransport: function unwrapFromTransport(msgData) {
    if (typeof msgData === "string" && (_state.env.useEagerSerialize || msgData.indexOf('"postal":true') !== -1)) {
      try {
        return JSON.parse(msgData);
      } catch (ex) {
        return {};
      }
    } else {
      return msgData;
    }
  },
  routeMessage: function routeMessage(event) {
    // source = remote window or worker?
    var source = event.source || event.currentTarget;
    var parsed = this.unwrapFromTransport(event.data);
    if (parsed.postal) {
      var remote = find(this.remotes, function (x) {
        return x.target === source;
      });
      if (!remote) {
        remote = _XFrameClient.default.getInstance(source, event.origin, parsed.packingSlip.instanceId);
        this.remotes.push(remote);
      }
      remote.onMessage(parsed.packingSlip);
    }
  },
  sendMessage: function sendMessage(env) {
    var envelope = env;
    if (_state.state.config.safeSerialize) {
      envelope = (0, _utils.safeSerialize)(cloneDeep(env));
    }
    this.remotes.forEach(function (remote) {
      remote.sendMessage(envelope);
    });
  },
  disconnect: function disconnect(options) {
    options = options || {};
    var clients = options.instanceId ?
    // an instanceId value or array was provided, let's get the client proxy instances for the id(s)
    (Array.isArray(options.instanceId) ? options.instanceId : [options.instanceId]).reduce(_utils._memoRemoteByInstanceId.bind(this), []) :
    // Ok so we don't have instanceId(s), let's try target(s)
    options.target ?
    // Ok, so we have a targets array, we need to iterate over it and get a list of the proxy/client instances
    (Array.isArray(options.target) ? options.target : [options.target]).reduce(_utils._memoRemoteByTarget.bind(this), []) :
    // aww, heck - we don't have instanceId(s) or target(s), so it's ALL THE REMOTES
    this.remotes;
    if (!options.doNotNotify) {
      clients.forEach(_utils._disconnectClient);
    }
    this.remotes = without.apply(null, [this.remotes].concat(clients));
  },
  signalReady: function signalReady(targets, callback) {
    var _this = this;
    targets = Array.isArray(targets) ? targets : [targets];
    targets = targets.length ? targets : this.getTargets();
    callback = callback || NO_OP;
    targets.forEach(function (def) {
      if (def.target) {
        def.origin = def.origin || _state.state.config.defaultOriginUrl;
        var remote = find(_this.remotes, function (x) {
          return x.target === def.target;
        });
        if (!remote) {
          remote = _XFrameClient.default.getInstance(def.target, def.origin);
          _this.remotes.push(remote);
        }
        remote.sendPing(callback);
      }
    });
  },
  addEventListener: _state.env.isWorker ? function () {
    addEventListener("message", listener);
  } : function (eventName, handler, bubble) {
    // in normal browser context
    if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
      window.addEventListener(eventName, handler, bubble);
    } else {
      throw new Error("postal.xframe only works with browsers that support window.addEventListener");
    }
  },
  listenToWorker: listenToWorker,
  stopListeningToWorker: function stopListeningToWorker(worker) {
    if (worker) {
      worker.removeEventListener("message", listener);
      _state.state.workers = without(_state.state.workers, worker);
    } else {
      while (_state.state.workers.length) {
        _state.state.workers.pop().removeEventListener("message", listener);
      }
    }
  }
};
plugin.addEventListener("message", listener, false);